import { onMount } from "svelte";
import { useEventDispatcher } from "./event-dispatcher.js";
import { setMountState, type ComponentMountable } from "../utils/waitForMount.js";

/**
 *
 *
 *
 *
 *
 */
export const useMountEvents = <E extends HTMLElement & ComponentMountable>(
  component: string,
  element: E,
): void => {
  const dispatch = useEventDispatcher(element, false);
  const payload = { component, element };

  onMount(() => {
    setMountState(element, true);
    dispatch(`${component}-mount`, payload, { cancelable: false, alias: ["oc-mount"] });

    return () => {
      setMountState(element, false);
      dispatch(`${component}-unmount`, payload, { cancelable: false, alias: ["oc-unmount"] });
    };
  });
};
